import { MANDATORY_FIELD } from '../../config/zodConfig';
import { z } from 'zod';

export const CommunicationFormSchema = z
  .object({
    id: z.number().optional(),
    name: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
    description: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
    initialDate: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
    validUntil: z
      .string({ message: MANDATORY_FIELD })
      .nonempty({ message: MANDATORY_FIELD }),
    image: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const initial = new Date(data.initialDate);
    const valid = new Date(data.validUntil);

    if (isNaN(initial.getTime()) || isNaN(valid.getTime())) return;

    if (valid < initial) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['validUntil'],
        message: 'A data de validade não pode ser anterior à data inicial.',
      });
    } else if (valid.getTime() - initial.getTime() < 24 * 60 * 60 * 1000) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['validUntil'],
        message: 'A validade deve ser de pelo menos 1 dia após a data inicial.',
      });
    }
  });
